"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootDetailAmpReducer = exports.detailPageReducer = void 0;
var redux_1 = require("redux");
var Pages_1 = require("@/rendering/common/Pages");
var RootPublicPageReducer_1 = require("@/pages/common/reducers/RootPublicPageReducer");
var DetailReducer_1 = require("@/pages/detail/reducers/DetailReducer");
var BreadcrumbReducer_1 = require("@/pages/search/reducers/BreadcrumbReducer");
var SfavReducer_1 = require("@/pages/search/reducers/SfavReducer");
var RootTrendsReducer_1 = require("@/pages/common/reducers/RootTrendsReducer");
var RootTransactionsReducer_1 = require("@/pages/common/reducers/RootTransactionsReducer");
exports.detailPageReducer = {
    page: function (state) {
        if (state === void 0) { state = Pages_1.Pages.PROPERTY_DETAIL; }
        return state;
    },
    breadcrumb: BreadcrumbReducer_1.breadcrumbReducer,
    detail: DetailReducer_1.detailReducer,
    sfav: SfavReducer_1.sFavReducer,
};
var combinedReducer = redux_1.combineReducers(__assign(__assign(__assign(__assign({}, RootPublicPageReducer_1.default), exports.detailPageReducer), RootTrendsReducer_1.rootTrendsReducer), RootTransactionsReducer_1.rootTransactionsReducer));
var rootDetailReducer = function (state, action) {
    if (action.type === 'SET_ALL_STATE_PROPERTY_DETAIL') {
        return __assign(__assign({}, state), action.payload);
    }
    return combinedReducer(state, action);
};
exports.rootDetailAmpReducer = function (state, action) {
    if (action.type === 'SET_ALL_STATE_PROPERTY_DETAIL_AMP') {
        return __assign(__assign({}, state), action.payload);
    }
    return combinedReducer(state, action);
};
exports.default = rootDetailReducer;
